import { AlertColor } from '@mui/material';
import { Store } from 'redux';
import { createAction } from 'typesafe-actions';

const showNotificationAction = createAction('@notifications/SHOW_NOTIFICATION')<{
  intlId: string;
  severity?: AlertColor;
  closeButtonIntlId?: string;
  message?: string;
  closeButtonText?: string;
}>();
export class NotificationService {
  constructor(private globalReduxStore: Store) {}

  public showNotification(intlId: string, severity?: AlertColor, closeButtonIntlId?: string): void {
    this.globalReduxStore.dispatch(showNotificationAction({ intlId, severity, closeButtonIntlId }));
  }

  public showNotificationMessage(
    message: string,
    severity?: AlertColor,
    closeButtonText?: string,
  ): void {
    this.globalReduxStore.dispatch(
      showNotificationAction({ intlId: '', severity, closeButtonText, message }),
    );
  }
}
